/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import useELDPortal from './hooks/useELDPortal';

interface ELDPortalContainerProps {
  collapsed?: boolean;
};

/**
 * The ELDPortalContainer component triggers a hook that creates/unmounts an iframe 
 * container that displays ELD Apollo User Portal within the app
 * or document level, throughout the user's session. It manages the visibility of the 
 * portal based on the current route.
 *
 * @returns {null}
 */

const ELDPortalContainer = ({
  collapsed
}: ELDPortalContainerProps) => {
  useELDPortal({collapsed});
  
  return null;
};

export default ELDPortalContainer;
